var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"st0",attrs:{"d":"M521.8,560L295,175.7L79.1,559.2L0.4,514.8L254.7,63c7.9-14.1,22.7-22.8,38.9-23c0.2,0,0.3,0,0.5,0\n\tc16,0,30.8,8.4,38.9,22.2L599.6,514L521.8,560z"}})}
var staticRenderFns = []

export { render, staticRenderFns }